import DealCreaPage from '@/components/DealCreaPage'

const UserCreate = () => <DealCreaPage showVehCreaButton={false} />

export default UserCreate
